import { devtools, subscribeWithSelector } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import type { IModule } from "@/ts/module";

export interface ModuleStoreState {
	modules: IModule[];
	actions: {
		addModule: (module: IModule) => void;
	};
	selectors: {
		moduleByName: (name: string) => IModule | undefined;
		moduleByNameCaseInsensitive: (name: string) => IModule | undefined;
	};
}

const initialState = {
	modules: [],
};

export const moduleStore = createStore<ModuleStoreState>()(
	devtools(
		subscribeWithSelector((set, get) => ({
			...initialState,
			actions: {
				addModule: (module: IModule) =>
					set((state) => {
						// don't add duplicates
						if (state.modules.some((mod) => mod === module)) {
							return state;
						}
						return {
							...state,
							modules: [...state.modules, module],
						};
					}),
			},
			selectors: {
				moduleByName: (name: string) => {
					const all = get().modules;
					// return first match, or undefined.
					return all.find((mod) => mod.name === name);
				},
				moduleByNameCaseInsensitive: (name: string) => {
					const all = get().modules;
					const lower = name.toLowerCase();
					return all.find((mod) => mod.name.toLowerCase() === lower);
				},
			},
		})),
		{
			name: "Hydra-ModuleStore",
		},
	),
);
